import { HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestService } from '@commonServices/request.service';
import { Client as ImportAPI, ImportJobDto } from "@interfaces/HttpClient/ImportApiModels";
import { firstValueFrom } from 'rxjs';
import { AdministrationService } from './administration.service';

@Injectable()
export class ImportService {

	constructor(
		private importApi: ImportAPI,
		private requestService: RequestService,
		private administrationService: AdministrationService
	) { }

	async getSupportedUploadFileExtensionsWithDot(importId: number): Promise<string[]> {
		try {
			return await firstValueFrom(this.importApi.import_GetSupportedUploadFileExtensionsWithDot(importId));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getImportProgress(catalogId: number): Promise<ImportJobDto> {
		try {
			return await firstValueFrom(this.importApi.import_GetImportProgress(catalogId));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getImportQueueState(): Promise<string> {
		try {
			return await firstValueFrom(this.importApi.importQueue_GetQueueState());
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async getImportRefresh(): Promise<void> {
		try {
			return await firstValueFrom(this.importApi.importQueue_Refresh());
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async cancelImport(): Promise<void> {
		try {
			return await firstValueFrom(this.importApi.import_CancelImport(this.administrationService.getId()));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}

	async importQueueLog(
		logFileName?: string | null | undefined
	): Promise<string> {
		try {
			return await firstValueFrom(this.importApi.importQueue_GetLogFile(logFileName));
		} catch (e) {
			return this.requestService.errorHandling(e, null, [
				{ status: HttpStatusCode.NoContent, return: undefined }
			]);
		}
	}
}
